import styled from 'styled-components';

export const Tag = styled.a`
	display: inline-block;
	position: relative;
	top: -1px;
	// margin-left: 7px;
	background-color: #b9b9b9;
	font-size: 8px;
	border-radius: 2px;
	color: #ffffff !important;
	font-weight: 400;
	letter-spacing: 0.5px;
	padding: 1px 4px;

	&:hover{
		background-color: #ffffff;
		color: #0d609d !important;
		text-decoration: none;
	}
`;
